<template>
	<div class="metric-tile" :class="{ 'metric-tile--large': large }" :style="toneStyle">
		<span class="metric-tile__value">
			<slot>{{ value }}</slot>
		</span>
		<span class="metric-tile__label">{{ label }}</span>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	label: { type: String, default: '' },
	value: { type: [String, Number], default: '' },
	color: { type: String, default: null },
	large: { type: Boolean, default: false },
});

const toneStyle = computed(() => (props.color ? { background: `rgba(var(--v-theme-${props.color}), 0.14)`, color: `rgb(var(--v-theme-${props.color}))` } : null));
</script>

<style scoped lang="scss">
@use '@/styles/variables' as *;

.metric-tile {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2px;
	min-width: 0;
	background: rgba(var(--v-theme-on-surface), 0.06);
	border-radius: 8px;
	padding: 6px 2px;
	text-align: center;

	&__value {
		display: flex;
		align-items: center;
		gap: 2px;
		font-size: $font-size;
		font-weight: 700;
	}

	&__label {
		font-size: 10px;
		color: rgba(var(--v-theme-on-surface), 0.6);
	}

	&--large {
		gap: 4px;
		border-radius: 12px;
		padding: 12px 4px;

		.metric-tile__value {
			gap: 4px;
			font-size: $font-size-extra-large;
		}

		.metric-tile__label {
			font-size: $font-size-small;
			text-transform: uppercase;
		}
	}
}
</style>

<style lang="scss">
.metric-tile-grid {
	display: grid;
	grid-template-columns: repeat(var(--metric-tile-grid-columns, 3), 1fr);
	gap: 6px;
}
</style>
